export default "__VITE_ASSET__5fe24313__"